<div class="upp-payment-ticket" uppDataid="stripe-ticket-pay">
    <upp-stripe-pay-button
        titleKey="@pay_now"
        subtitleKey="@pay_ticket"
        [disabled]="!CanPay"
        (payClick)="OnPay()">
    </upp-stripe-pay-button>
</div>
